import {
  AI_QUESTION_ERROR_MESSAGE_RAISED,
  AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR,
  AI_RESPONSE_HAVE_LOADED,
  AI_RESPONSE_ARE_LOADING,
  AI_RESPONSE_CLOSE_MODAL,
} from "../actions/actionTypes";

import { ASK_QUESTION, ASK_QUESTION_DOCUMENT } from "../constants/urls";

import axios from "axios";

export function aiQuestionErrorMessageRaised(aiQuestionErrorMessage) {
  console.log("aiQuestionErrorMessage", aiQuestionErrorMessage);
  return {
    type: AI_QUESTION_ERROR_MESSAGE_RAISED,
    aiQuestionErrorMessage,
  };
}

export function aiQuestionAreLoadedWithError() {
  return {
    type: AI_QUESTION_HAVE_BEEN_LOADED_WITH_ERROR,
  };
}

export function aiResponseAreLoaded(response) {
  return {
    type: AI_RESPONSE_HAVE_LOADED,
    response,
  };
}
export function aIResponseAreLoading() {
  return {
    type: AI_RESPONSE_ARE_LOADING,
  };
}

export function aIResponseCloseModal() {
  return {
    type: AI_RESPONSE_CLOSE_MODAL,
  };
}

export function aIQuestionDocument(
  usertoken,
  reference_id,
  topic_id,
  AI_tokens,
  question
) {
  return (dispatch) => {
    dispatch(aIResponseAreLoading(true));
    axios({
      url: ASK_QUESTION_DOCUMENT,
      params: {
        usertoken,
        reference_id,
        topic_id,
        AI_tokens,
        question,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(aiResponseAreLoaded(response.data.RegHub_response));
        sessionStorage.setItem("commonAI_REQUEST", false);
        // sessionStorage.removeItem("separateNewsAsk");
        // sessionStorage.removeItem("reference_id");
      })
      .catch((err) => {
        dispatch(aiQuestionAreLoadedWithError());
        dispatch(
          aiQuestionErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}
export function aIQuestion(
  usertoken,
  freeText,
  topic_search_tags,
  publicationTypes,
  fromDate,
  toDate,
  publisherTypes,
  countries,
  topic_id,
  question,
  max_num_news,
  AI_tokens,
  Show_Sources
) {
  return (dispatch) => {
    dispatch(aIResponseAreLoading(true));
    axios({
      url: ASK_QUESTION,
      params: {
        usertoken,
        freeText,
        topic_search_tags,
        publicationTypes,
        fromDate,
        toDate,
        publisherTypes,
        countries,
        topic_id,
        question,
        max_num_news,
        AI_tokens,
        Show_Sources,
      },
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "aplication/json",
      },
    })
      .then((response) => {
        dispatch(aiResponseAreLoaded(response.data.RegHub_response));
        sessionStorage.setItem("commonAI_REQUEST", true);
        // sessionStorage.removeItem("separateNewsAsk");
        // sessionStorage.removeItem("reference_id");
      })
      .catch((err) => {
        dispatch(aiQuestionAreLoadedWithError());
        dispatch(
          aiQuestionErrorMessageRaised(err.response ? err.response.data : err)
        );
      });
  };
}
